import React, { Component } from 'react';
import DemoImage from './DemoImage';
export default class SocialPanel extends Component {

  render(){
    return this.props.publicId
      ? (
        <section className="website">
          <header className="sub-heading">
            <h2>Social sites &amp; apps</h2>
            <p>Manage a very high volume of images uploaded by users, presenting profile photos and user albums in many styles and sizes. You can serve billions of dynamically manipulated images fitting any graphic design and look & feel.</p>
          </header>
          <div className="web-social">
            <div className="browser-head">
              <ul className="list-inline bullets">
                <li>bullet</li>
                <li>bullet</li>
                <li>bullet</li>
              </ul>
            </div>
            <header className="header">
              <strong className="logo text-uppercase">Friends</strong>
              <ul className="right list-inline">
                <li className="username">
                  <DemoImage {...this.props} transformation={{dpr: 'auto', crop: 'thumb', aspect_ratio: 1, radius: 'max', gravity: 'face', width: 'auto'}} format="png" className="img">
                    <p>Create a profile photo thumbnail.</p><ul><li>Focus on the auto-detected face</li><li>Resize the image to thumbnail size</li><li>Crop to a circle</li></ul>
                  </DemoImage>
                  <strong className="txt text-capitalize">Jamie</strong>
                </li>
                <li className="hidden-md hidden-lg"><span className="icon-msg01" /></li>
                <li className="hidden-md hidden-lg"><span className="icon-earth" /></li>
                <li className="hidden-md hidden-lg"><span className="icon-magnify" /></li>
                <li><span className="icon-bar" /></li>
                <li className="hidden-xs hidden-sm"><span className="icon-lock" /></li>
                <li className="hidden-xs hidden-sm"><span className="icon-gear" /></li>
              </ul>
              <div className="search-box hidden-sm hidden-xs">
                <span className="icon-magnify" />
                <span className="input">Find friends</span>
              </div>
            </header>
            <div className="main">
              <nav className="side-menu hidden-xs hidden-sm">
                <strong className="title text-uppercase">Menu</strong>
                <ul className="list-unstyled text-capitalize">
                  <li>Edit Profile</li>
                  <li className="active">News Feed</li>
                  <li>Messages</li>
                  <li>Events</li>
                  <li>Favorites</li>
                  <li>Groups</li>
                  <li>Friends</li>
                </ul>
              </nav>
              <div className="content">
                <div className="white-box">
                  <div className="user">
                    <DemoImage {...this.props} transformation={{dpr: 'auto', crop: 'thumb', aspect_ratio: 1, radius: 'max', gravity: 'face', width: 'auto', zoom: 0.8}} format="png" className="img">
                      <p>Create a profile photo thumbnail.</p><ul><li>Focus on the auto-detected face</li><li>Resize the image to thumbnail size</li><li>Crop to a circle</li><li>Zoom out a bit</li></ul>
                    </DemoImage>
                    <div className="desc">
                      <h2 className="text-capitalize">Jamie Jones</h2>
                      <time dateTime="PT5M">5 minutes ago</time>
                    </div>
                  </div>
                  <p>Showcase photos from an event, a family vacation, a birthday or any day in a collage. Cloudinary will crop your images optimally by focusing on auto-detected areas of interest.</p>
                  <div className="img-gal">
                    <DemoImage {...this.props} transformation={{dpr: 'auto', crop: 'fill', aspect_ratio: '640:317', gravity: 'faces', effect: 'art:red_rock', width: 'auto'}} format="jpg" className="img" useTag={true}>
                      <ul><li>Resize and crop the main image to optimally fit the relevant size</li><li>Focus on automatically detected faces</li><li>Apply an artistic filter</li></ul>
                    </DemoImage>
                    <ul className="img-list list-inline">
                      <li>
                        <DemoImage {...this.props} transformation={{dpr: 'auto', crop: 'thumb', aspect_ratio: '202:124', gravity: 'face', effect: 'art:primavera', width: 'auto'}} format="jpg" className="img" useTag={true}>
                          <p>Create a thumbnail dynamically.</p><ul><li>Focus on the auto-detected face</li><li>Crop and resize the image</li><li>Apply an artistic effect</li></ul>
                        </DemoImage>
                      </li>
                      <li>
                        <DemoImage {...this.props} transformation={{dpr: 'auto', crop: 'fill', aspect_ratio: '265:124', gravity: 'auto', effect: 'art:primavera', width: 'auto'}} format="jpg" className="img" useTag={true}>
                          <ul><li>Crop and resize the image to a different aspect ratio</li><li>Focus on the auto-detected area of interest</li><li>Apply an artistic effect</li></ul>
                        </DemoImage>
                      </li>
                      <li>
                        <DemoImage {...this.props} transformation={[{dpr: 'auto', crop: 'fill', aspect_ratio: '167:124', width: 'auto'}, { effect: 'brightness_hsb:-50' }, { overlay: 'text:Arial_45px:+5', color: 'white' }]} format="jpg" className="img" useTag={true}>
                          <ul><li>Crop and resize the image to the relevant size</li><li>Adjust the image brightness in HSB</li><li>Add a dynamic text overlay indicating how many more photos are available for this post</li></ul>
                        </DemoImage>
                      </li>
                    </ul>
                    <ul className="social-shares list-inline">
                      <li><span className="icon-heart" /> Like</li>
                      <li><span className="icon-msg" /> Comment</li>
                      <li><span className="icon-tri-cirlcle" /> Share</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="note">
                <p>With Cloudinary, you can handle any images uploaded by your users and present them in a compelling way.</p>
                <p>Create thumbnails of profile photos on-the-fly in any style and size by detecting faces automatically, crop any image uploaded by your users to fit your graphic design, and deliver images super fast, in optimal quality.</p>
              </div>
            </div>
          </div>
        </section>
      )
      : null;
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/SocialPanel.js
 **/